/**
 * 创建人：DR
 * 时间：2020年8月20日17:58:33
 * 描述：首页布局依赖的基础组件
 * 使用说明: 
 */
import { PlatformLocation } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SwChangePasswordComponent } from 'src/app/home/sw-change-password/sw-change-password.component';
import { SwLockSystemComponent } from 'src/app/home/sw-lock-system/sw-lock-system.component';
import { SwPersonViewComponent } from 'src/app/home/sw-person-view/sw-person-view.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { SwWebSocketService } from 'src/app/librarys/serves/sw-web-socket.service';
import { environment } from 'src/environments/environment';
import { EventService } from '../../basic-components/sw-ng-grid/service/event.service';

// 组件样式，1，列表型，2，数字汇总型，3，报表型，4，快捷菜单型，5，日历型，6，磁贴型
@Component({
  selector: 'sw-charts-basic',
  templateUrl: './charts-basic.component.html',
  styleUrls: ['./charts-basic.component.css']
})
export class ChartsBasicComponent implements OnInit {

  @Input() data;//传递的参数，根据此生成组件

  type: any = 'echarts';//当前展示的类型是图表还是表格还是磁贴

  portalStatus: any = true; //当前编辑状态，防止磁贴跳转和拖动手势切换

  echarts: any;
  chartOptions: any;//报表配置
  echartColor: string = 'pie'//判断echart点击类型
  echartsData: any = [];  //报表转化后的数据
  datas: any = []//数据源
  tabControls: any[] = [{ id: '1', text: '待处理' }, { id: '2', text: '已处理' }, { id: '3', text: '已发起' }]  //选项卡数组
  gridType: string = '1'  //默认选项卡选中表格类型

  gender: any  //当前用户的性别
  UserModel: any = {}; //当前用户信息
  position: any //当前用户主岗信息
  //用户常用头像
  userImage: any = "";
  constructor(private router: Router, 
    private jwt: SwJwtService, 
    private eventService: EventService, 
    private create: SwCreateModalComponentService, 
    private websoket: SwWebSocketService,
    private http: SwHttpClientService, 
    private menu: SwMenuService, 
    private User: GetUserModelService,
    private box: SwMassageBoxService,
    private Location: PlatformLocation, 
    ) {
    //获取用户信息
  }

  ngOnInit() {
    this.portalStatus = this.menu.getStaticPortalStatus();
    //先订阅当前状态,发生变化后则处理
    this.menu.portalStatus.subscribe(val => {
      if (val == true) {
        this.portalStatus = true;
        this.menu.setStaticPortalStatus(true);
      } else {
        this.portalStatus = false;
        this.menu.setStaticPortalStatus(false);
      }
    })
    this.init();
  }

  //初始化渲染数据
  init() {
    //进来先判断参数是否存在
    if (this.data) {
      this.type = this.data.widgetStyle;
      //需要用到用户个人信息，从缓存中获取
      if (this.type == 7) {
        this.UserModel = this.User.getUser();
        this.gender = this.UserModel['userDetail']['gender'];
        this.position = JSON.parse(this.jwt.getToken('position'));
        this.userImage = this.User.getUserImage()[0];

        let Params = { ids: [this.UserModel.userId] }
        //请求数据获取用户基础数据
        this.http.Post(environment.seekerWebAPI + "user/queryById", Params).subscribe(
          data => {
            if (data['code'] == 200) {
              //用户基础信息
              let detail = data["data"]["userDetail"]
              if (detail.fax) {
                this.userImage = detail.fax;
              }
            }
          })
      }
      if (this.data.dataUrl == null || this.data.dataUrl == '') {
        //没有的话不请求
        return;
      }
      let urlHeader = "" //请求地址前缀，根据模块来判断,不存在则默认设置为basic
      if (!this.data.module) {
        this.data.module = "BASIC";
      }

      if (this.data.module == "ACTIVITI") {
        urlHeader = environment.activitiWebAPI;
      } else if (this.data.module == "FILE") {
        urlHeader = environment.fileWebAPI;
      } else if (this.data.module == "BASIC") {
        urlHeader = environment.seekerWebAPI;
      } else {
        let moduleName = this.data.module.replace('_', '').toLowerCase() + "WebAPI";
        if (environment[moduleName]) {
          urlHeader = environment[moduleName];
        } else {
          urlHeader = environment.seekerWebAPI;
        }
      }

      const url = urlHeader + this.data.dataUrl;  //请求地址 dataUrl第一个不要带/
      if (this.data.widgetStyle == 1) {
        this.http.Post(url, null).subscribe(response => {
          if (response["code"] == 200) {
            //处理逻辑
            this.datas = response["data"];
          } else {
            //虚构出一个对象
            this.datas = [[{ name: '', value: '' }]];
          }
        });
      } else if (this.data.widgetStyle == 2) {
        //数字汇总型处理逻辑
        this.http.Post(url, null).subscribe(response => {
          if (response["code"] == 200) {
            //处理逻辑
            this.datas = response["data"];
          } else {
            //虚构出一个对象
            this.datas = [{ "label": null, "name": null, "value": null }];
          }
        });
      } else if (this.data.widgetStyle == 3) {
        //报表型
        this.http.Post(url, null).subscribe(response => {
          if (response["code"] == 200) {
            //处理逻辑
            this.datas = response["data"];
            this.echartsDataSource("bar");
          } else {
            //虚构出一个对象
            this.datas = [{ "label": null, "name": null, "value": null }];
            this.echartsDataSource("bar");
          }
        });
      }
    }
  }


  chartInit(event) {
    this.echarts = event;
  }

  //磁贴链接跳转方法
  RouterLinek(url, title = '', param = null) {
    let openType=this.data.openType;
    if (url && this.portalStatus != true) {
      //默认方式打开
      let uri = url;

      if (param) {
        if (openType == 1) {
          uri="/#" + uri;
          uri += "?";
          for (let key in param) {
            if (key == "params") {
              uri += "&" + key + "=" + JSON.stringify(param[key]);
              continue;
            }
            uri += "&" + key + "=" + param[key];
          }
          window.open(uri)
        } else {
          // let uri = 'http://localhost:4510/#/login?functionCode=drm&RedirectUrl=/drm/CommonResourceQuery';
          //在跳转地址中找到对应的模块
          let arr = uri.split('/')
          let functionCode = arr[1]
          // 如果是 分站点配置 或者是 跳转到 oa 或 bdp
          if(environment["enableModuleDeploy"] && functionCode.toLocaleLowerCase() != 'oa' && functionCode.toLocaleLowerCase() != 'bdp'){
            let sites:any = environment["moduleSites"]
            if(sites){
              sites = JSON.parse(sites)
              //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
              let path = this.Location["location"].href
              let currentSite = path.split('#')[0].toLocaleLowerCase()
              let currentSiteFunctionCode
              //找到当前地址栏是属于哪个模块的站点地址
              for (const key in sites) {
                if(sites[key].indexOf(currentSite) > -1){
                  currentSiteFunctionCode = key
                }
              }
              //如果要跳转的模块与当前模块一致
              if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                //不使用分站点设置，就普通跳转
                this.router.navigate([uri], {
                  queryParams: param,
                });
              } else {
                let site = sites[functionCode.toLocaleLowerCase()]
                if(site){
                  //看配置的站点信息中有没有参数
                  let siteInfo = site.split('?')
                  if(siteInfo.length >=2){  //如果有站点信息
                    site = siteInfo[0]    //单纯的站点,不带参数的
                  }
                  //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                  let token = this.jwt.getlocaToken('token')
                  let systemId = this.jwt.getlocaToken('systemId')
                  let queryParams = JSON.stringify(param)
                  let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+uri+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                  window.open(newUri)  //用不同的站点打开不同的模块
                } else {
                  this.box.danger('缺少该模块站点配置项')
                }

              }
            } else {
              this.box.danger('缺少站点配置项')
            }

          } else {
            //不使用分站点设置，就普通跳转
            this.router.navigate([uri], {
              queryParams: param,
            });
          }
        }
      } else {
        //默认方式打开,根据路由跳转链接
        if (openType == 1) {
          uri += "?Title=" + title;
          window.open(uri) 
        } else {
          // let uri = 'http://localhost:4510/#/login?functionCode=drm&RedirectUrl=/drm/CommonResourceQuery';
          //在跳转地址中找到对应的模块
          let arr = uri.split('/')
          let functionCode = arr[1]
          if(environment["enableModuleDeploy"] && functionCode.toLocaleLowerCase() != 'oa' && functionCode.toLocaleLowerCase() != 'bdp'){
            let sites:any = environment["moduleSites"]
            if(sites){
              sites = JSON.parse(sites)
              //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
              let path = this.Location["location"].href
              let currentSite = path.split('#')[0].toLocaleLowerCase()
              let currentSiteFunctionCode
              //找到当前地址栏是属于哪个模块的站点地址
              for (const key in sites) {
                if(sites[key].indexOf(currentSite) > -1){
                  currentSiteFunctionCode = key
                }
              }
              if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                //不使用分站点设置，就普通跳转
                this.router.navigate([uri], {
                  queryParams: { Title: title },
                });
              } else {
                let site = sites[functionCode.toLocaleLowerCase()]
                if(site){
                  //看配置的站点信息中有没有参数
                  let siteInfo = site.split('?')
                  if(siteInfo.length >=2){  //如果有站点信息
                    site = siteInfo[0]    //单纯的站点,不带参数的
                  }
                  //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                  let token = this.jwt.getlocaToken('token')
                  let systemId = this.jwt.getlocaToken('systemId')
                  let queryParams = JSON.stringify({ Title: title })
                  let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+uri+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                  window.open(newUri)  //用不同的站点打开不同的模块
                } else {
                  this.box.danger('缺少该模块站点配置项')
                }

              }
            } else {
              this.box.danger('缺少站点配置项')
            }

          } else {
            //不使用分站点设置，就普通跳转
            this.router.navigate([uri], {
              queryParams: { Title: title },
            });
          }
        }
      }
    }
  }

  //用于页面调用方法
  JsonToStr(obj){
    if(obj){
      return JSON.stringify(obj);
    }
  }

  /**
 * 点击选项卡
 * @ignore
 */
  clickTab(data) {
    this.gridType = data.id
  }

  //流程更多按钮跳转链接
  processLink(gridType) {
    let uri = "", title = "";
    if (gridType == "1") {
      uri = "/oa/ToDoProcess";
      title = "待办流程";
    } else if (gridType == "2") {
      uri = "/oa/CompletionProcess"
      title = "已办流程";
    } else if (gridType == "3") {
      uri = "/oa/PublishedProcess"
      title = "已发流程";
    }
    // let uri = 'http://localhost:4510/#/login?functionCode=drm&RedirectUrl=/drm/CommonResourceQuery';
    //在跳转地址中找到对应的模块
    let arr = uri.split('/')
    let functionCode = arr[1]
    if(environment["enableModuleDeploy"] && functionCode.toLocaleLowerCase() != 'oa' && functionCode.toLocaleLowerCase() != 'bdp'){
      let sites:any = environment["moduleSites"]
      if(sites){
        sites = JSON.parse(sites)
        //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
        let path = this.Location["location"].href
        let currentSite = path.split('#')[0].toLocaleLowerCase()
        let currentSiteFunctionCode
        //找到当前地址栏是属于哪个模块的站点地址
        for (const key in sites) {
          if(sites[key].indexOf(currentSite) > -1){
            currentSiteFunctionCode = key
          }
        }
        if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
          //默认方式打开,根据路由跳转链接
          this.router.navigate([uri], {
            queryParams: { Title: title },
          });
        } else {
          let site = sites[functionCode.toLocaleLowerCase()]
          if(site){
            //看配置的站点信息中有没有参数
            let siteInfo = site.split('?')
            if(siteInfo.length >=2){  //如果有站点信息
              site = siteInfo[0]    //单纯的站点,不带参数的
            }
            //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
            let token = this.jwt.getlocaToken('token')
            let systemId = this.jwt.getlocaToken('systemId')
            let queryParams = JSON.stringify({ Title: title })
            let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+uri+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
            window.open(newUri)  //用不同的站点打开不同的模块
          } else {
            this.box.danger('缺少该模块站点配置项')
          }

        }
      } else {
        this.box.danger('缺少站点配置项')
      }

    } else {
      //默认方式打开,根据路由跳转链接
      this.router.navigate([uri], {
        queryParams: { Title: title },
      });
    }
  }


  //echart初始化
  echartsDataSource(type) {
    this.echartsData.splice(0, this.echartsData.length);
    this.datas.forEach(item => {
      this.echartsData.push({ name: item.label, value: item.value })
    });
    if (type) {
      if (type == "bar") {
        //图表类》柱状图
        this.getBar();
      } else if (type == "line") {
        //图表类》折线图
        this.getLine();

      } else if (type == "pie") {
        //图表类》饼图
        this.getPie();
      }
    }
  }

  //饼状图
  getPie() {
    this.echartColor = 'pie';
    this.chartOptions = {
      series: [
        {
          type: "pie",
          data: this.echartsData
        }
      ]
    };
  }
  //折线图
  getLine() {
    this.echartColor = 'line';
    let xData = [];
    let yData = [];
    for (let i = 0; i < this.echartsData.length; i++) {
      xData.push(this.echartsData[i].name);
      yData.push(this.echartsData[i].value);
    }
    this.chartOptions = {
      tooltio: {},
      xAxis: {
        data: xData
      },
      yAxis: {},
      series: [
        {
          type: "line",
          data: yData
        }
      ]
    };
  }
  //柱状图
  getBar() {
    this.echartColor = 'bar';
    let xData = [];
    let yData = [];
    for (let i = 0; i < this.echartsData.length; i++) {
      xData.push(this.echartsData[i].name);
      yData.push(this.echartsData[i].value);
    }
    this.chartOptions = {
      tooltio: {},
      xAxis: {
        data: xData
      },
      yAxis: {},
      series: [
        {
          type: "bar",
          data: yData
        }
      ]
    };
  }

  //刷新数据
  reload(id) {
    this.init();
  }

  //移除
  public delGrid(data) {
    this.eventService._event.emit('removeGrid', data.id);
    this.menu.changeDeleteWidget(data.widgetId);
  }

  //表格切换选项卡时触发
  ovtedTab(data) {
    this.gridType = data.id
  }

  //点击个人信息
  ClickPerson() {
    //打开个人信息页面
    // this.personView.ClickLoca();
    this.create.createModal(SwPersonViewComponent, {})
  }

  //修改密码
  ClickChangePassword() {
    // this.changePassword.ClickLoca();
    this.create.createModal(SwChangePasswordComponent, {})
  }

  //锁定系统
  ClickLockSystem() {

    this.webSoketClose();
    // //清除token
    // this.swJwtService.removeItem("token");
    //打开锁定系统
    // this.lockSystem.ClickLoca();
    this.create.createModal(SwLockSystemComponent, {}, this.webSocketOpen.bind(this))
  }

  //关闭websoket连接
  webSoketClose() {
    this.websoket.close()
  }

  //打开websoket连接
  webSocketOpen() {
    this.websoket.open()
    // this.process.oninitNotice()
  }
}
